import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { FormService } from '../../../../../services/form-service.service';
import { MasterService } from "../../../../../services/master.service";
import { MessageService } from "../../../../../services/message.service";
import { StoreService } from "../../../../../services/store.service";
import * as languageLibrary from '../../../../../services/language'
import moment from 'moment';

@Component({
    selector: 'dynamic-setup-form',
    templateUrl: './dynamic-setup-form.component.html',
    styleUrls: ['./dynamic-setup-form.component.scss'],
    standalone: false
})
export class DynamicSetupFormComponent implements OnInit {

    @Input() setupValues: Array<any> = null

    @Input() selectedForm: any = null

    @Input() inventoryId: number | null = null

    @Input() saleId: number | null = null

    protected dynamicForm: FormGroup;
    protected dynamicTableForm: FormGroup;

    private lotId: number | null = null

    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    protected privacyNoticeForm: FormGroup;

    protected itemsOwedForm: FormGroup;

    get weOweItems() {
        return this.itemsOwedForm.controls['weOweItems'] as FormArray;
    }
    get youOweItems() {
        return this.itemsOwedForm.controls['youOweItems'] as FormArray;
    }
    constructor(private formBuilder: FormBuilder, private formService: FormService, private ms: MessageService, private master: MasterService, private store: StoreService) {
        this.privacyNoticeForm = this.formBuilder.group({
            whatInformationCollected1: new FormControl<string>("Social Security Number"),
            whatInformationCollected2: new FormControl<string>("Account Balances"),
            whatInformationCollected3: new FormControl<string>("Credit History"),
            whatInformationCollected4: new FormControl<string>("Income"),
            whatInformationCollected5: new FormControl<string>("Payment History"),
            whatInformationCollected6: new FormControl<string>("Employment Information"),
            reasons1: new FormControl<string>("Yes"),
            customerLimit1: new FormControl<string>("We don't share"),
            reasons2: new FormControl<string>("Yes"),
            customerLimit2: new FormControl<string>("We don't share"),
            reasons3: new FormControl<string>("Yes"),
            customerLimit3: new FormControl<string>("We don't share"),
            reasons4: new FormControl<string>("Yes"),
            customerLimit4: new FormControl<string>("We don't share"),
            reasons5: new FormControl<string>("Yes"),
            customerLimit5: new FormControl<string>("We don't share"),
            reasons6: new FormControl<string>("Yes"),
            customerLimit6: new FormControl<string>("We don't share"),
            reasons7: new FormControl<string>("Yes"),
            customerLimit7: new FormControl<string>("We don't share"),
            limitSharingDays: new FormControl<number>(30),
            howInformationCollected1: new FormControl<string>("Apply for a loan or show your driver's license."),
            howInformationCollected2: new FormControl<string>("Pay your bills or give us your contact information"),
            howInformationCollected3: new FormControl<string>("Provide employment information"),
            howInformationCollectedAlso: new FormControl<string>("We also collect your personal information from others such as credit bureaus, affiliates, or other companies."),
            mailInForm: new FormControl<string>("_______ Do not sell"),
        })

        this.itemsOwedForm = this.formBuilder.group({
            weOweItems: this.formBuilder.array([]),
            youOweItems: this.formBuilder.array([])
        })
    }

    ngOnInit() {
        this.lotId = parseInt(localStorage.getItem('lot') || this.store.lotSelected)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        this.privacyNoticeForm.disable()
        this.itemsOwedForm.disable()

        if ((!changes.setupValues || !changes.setupValues.currentValue) && (!changes.selectedForm || !changes.selectedForm.currentValue)) {
            return
        }

        if (this.selectedForm['name'] == 'Privacy Notice') {
            this.setPrivacyNoticeInformation(changes.setupValues.currentValue)
            return
        }

        if (this.selectedForm['name'] == 'Items Owed Agreement') {
            this.buildDynamicFormTable(changes.setupValues.currentValue)
            return
        }

        this.buildDynamicForm(changes.setupValues.currentValue)
    }

    public async buildDynamicForm(setupValues) {
        this.dynamicForm = null
        this.setupValues = JSON.parse(setupValues)
        const formStructure = await this.formService.getFormStructure(this.setupValues);

        let formGroup = {};
        formStructure.forEach(control => {
            formGroup[control.name] = [control.value || ''];
        });

        this.dynamicForm = this.formBuilder.group(formGroup);
    }

    public async buildDynamicFormTable(setupValues) {
        this.dynamicForm = null
        this.setupValues = JSON.parse(setupValues)
        this.privacyNoticeForm.disable()
        this.itemsOwedForm.enable()
        const formStructure = await this.formService.getFormStructure(this.setupValues);

        formStructure.forEach(control => {
            this.add(control)
        });
    }

    public add = (control): void => {
        let item = null
        let oweTo = null
        if (control.length > 0) {
            item = this.formBuilder.group({
                dateOwed: [control[0].value || moment(new Date()).format("YYYY-MM-DD")],
                itemOwed: [control[1].value],
                owedTo: [control[2].value],
                dateEntered: [control[3].value || moment(new Date()).format("YYYY-MM-DD")],
            });
            oweTo = control[2].value
        } else {
            item = this.formBuilder.group({
                dateOwed: [control['dateOwed'] || moment(new Date()).format("YYYY-MM-DD")],
                itemOwed: [control['itemOwed'] || null],
                owedTo: [control['owedTo'] || null],
                dateEntered: [control['dateEntered'] || moment(new Date()).format("YYYY-MM-DD")],
            })
            oweTo = control['owedTo']

        }

        if (oweTo == 'Buyer') {
            this.weOweItems.push(item)
        } else {
            this.youOweItems.push(item)
        }

    }
    public addNew = (oweTo): void => {
        let item = null

        item = this.formBuilder.group({
            dateOwed: [moment(new Date()).format("YYYY-MM-DD")],
            itemOwed: [null],
            owedTo: [oweTo],
            dateEntered: [moment(new Date()).format("YYYY-MM-DD")],
        })

        if (oweTo == 'Buyer') {
            this.weOweItems.push(item)
        } else {
            this.youOweItems.push(item)
        }

    }

    public updateTable = (e: Event, i) => {
        let element = e.target
        let id = element['id']
        let owedTo = id.includes('dealer') ? 'Dealer' : 'Buyer'
        let field = id.includes('itemOwed') ? 'itemOwed' : id.includes('dateEntered') ? 'dateEntered' : 'dateOwed'
        if (owedTo == "Dealer") {
            this.weOweItems.controls[i].get(field).setValue((e.target as HTMLInputElement).value)
            return
        }
        this.youOweItems.controls[i].get(field).setValue((e.target as HTMLInputElement).value)

    }

    public updateValue = (e) => {
        let element = e.target
        if (!this.setupValues[element.name]) {
            return
        }
        this.setupValues[element.name]['value'] = e.target.type !== 'checkbox' ? element.value : element.checked
    }

    public updatePrivacyNoticeValue = (e) => {
        let element = e.target
        this.setupValues[element.name] = element.value
    }

    /**
    * saveDefaults
    */
    public saveDefaults = async () => {
        let inventoryParam = ''
        if (this.inventoryId > 0) {
            inventoryParam = `&inventoryId=${this.inventoryId}`
        }
        let saleParam = ''
        if (this.saleId > 0) {
            saleParam = `&saleId=${this.saleId}`
        }

        if (this.itemsOwedForm.enabled) {
            this.setupValues = this.weOweItems.value.concat(this.youOweItems.value)
        }

        const res = await this.master.postAsync(`forms/${this.selectedForm['id']}?lotId=${this.lotId}${inventoryParam}${saleParam}`, { setupValues: JSON.stringify(this.setupValues) })

        if (!res || (res['status'] !== 200)) {
            this.ms.sendMessage("alert", { type: "danger", text: res ? res['data'].error : this.words[this.language]['apiNoResponse'] })
            return
        }

        document.getElementById('btn-close-dynamicSetupForm').click()
    }

    public setContactIdEvent(e) {
        let setupValuesIndex = this.setupValues.findIndex(res => res["name"] == "contactWarrantyId")
        this.setupValues[setupValuesIndex]['value'] = e
    }

    public setPrivacyNoticeInformation(setupValues) {
        this.dynamicForm = null
        this.setupValues = JSON.parse(setupValues)
        this.privacyNoticeForm.enable()
        this.privacyNoticeForm.setValue({
            whatInformationCollected1: this.setupValues['whatInformationCollected1'],
            whatInformationCollected2: this.setupValues['whatInformationCollected2'],
            whatInformationCollected3: this.setupValues['whatInformationCollected3'],
            whatInformationCollected4: this.setupValues['whatInformationCollected4'],
            whatInformationCollected5: this.setupValues['whatInformationCollected5'],
            whatInformationCollected6: this.setupValues['whatInformationCollected6'],
            reasons1: this.setupValues['reasons1'],
            customerLimit1: this.setupValues['customerLimit1'],
            reasons2: this.setupValues['reasons2'],
            customerLimit2: this.setupValues['customerLimit2'],
            reasons3: this.setupValues['reasons3'],
            customerLimit3: this.setupValues['customerLimit3'],
            reasons4: this.setupValues['reasons4'],
            customerLimit4: this.setupValues['customerLimit4'],
            reasons5: this.setupValues['reasons5'],
            customerLimit5: this.setupValues['customerLimit5'],
            reasons6: this.setupValues['reasons6'],
            customerLimit6: this.setupValues['customerLimit6'],
            reasons7: this.setupValues['reasons7'],
            customerLimit7: this.setupValues['customerLimit7'],
            limitSharingDays: this.setupValues['limitSharingDays'],
            howInformationCollected1: this.setupValues['howInformationCollected1'],
            howInformationCollected2: this.setupValues['howInformationCollected2'],
            howInformationCollected3: this.setupValues['howInformationCollected3'],
            howInformationCollectedAlso: this.setupValues['howInformationCollectedAlso'],
            mailInForm: this.setupValues['mailInForm']
        })
    }
}
